import { render, staticRenderFns } from "./FlagDialog.vue?vue&type=template&id=32213779&"
import script from "./FlagDialog.vue?vue&type=script&lang=ts&"
export * from "./FlagDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports